import { render, staticRenderFns } from "./DialogPageNav.vue?vue&type=template&id=831f8bc6"
import script from "./DialogPageNav.vue?vue&type=script&lang=js"
export * from "./DialogPageNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports